const versionNameKey = 'current_version_name';
const versionidKey = 'current_version_id';

export const getCurrentVersionName = () => {
  return sessionStorage.getItem(versionNameKey);
};

export const getCurrentVersionid = () => {
  return sessionStorage.getItem(versionidKey);
};

export const setCurrentVersionName = (name: string) => {
  return sessionStorage.setItem(versionNameKey, name);
};

export const setCurrentVersionid = (name: string) => {
  return sessionStorage.setItem(versionidKey, name);
};
